import { LanguageCode } from '@/types/languageCodes';

export const LANGUAGE_LABELS: Record<LanguageCode, string> = {
  [LanguageCode.English]: 'English',
  [LanguageCode.Mandarin]: 'Mandarin',
  [LanguageCode.Arabic]: 'Arabic',
  [LanguageCode.Vietnamese]: 'Vietnamese',
  [LanguageCode.Cantonese]: 'Cantonese',
  [LanguageCode.Punjabi]: 'Punjabi',
  [LanguageCode.Greek]: 'Greek',
  [LanguageCode.Italian]: 'Italian',
  [LanguageCode.Hindi]: 'Hindi',
  [LanguageCode.Spanish]: 'Spanish',
  [LanguageCode.Yumplatok]: 'Yumplatok (Torres Strait Creole)',
  [LanguageCode.Kriol]: 'Kriol',
  [LanguageCode.Djambarrpuyngu]: 'Djambarrpuyngu',
};

export const LANGUAGE_MULTISELECT_OPTIONS = Object.entries(LANGUAGE_LABELS).map(
  ([code, label]) => ({
    value: code as LanguageCode,
    label,
  }),
);

export function getLanguageLabel(code: LanguageCode): string {
  return LANGUAGE_LABELS[code] ?? code;
}

export function mapLanguageCodesToLabels(codes: LanguageCode[]): string[] {
  return codes.map((code) => getLanguageLabel(code));
}
